<template>
    <div>
        <b-icon @click="click(1)" @mouseover="hoverIn(1)" @mouseleave="hoverOut(0)" :icon="starIcon1" :font-scale="fontScale" :style="style1" class="mr-1"/>
        <b-icon @click="click(2)" @mouseover="hoverIn(2)" @mouseleave="hoverOut(0)" :icon="starIcon2" :font-scale="fontScale" :style="style2" class="mr-1"/>
        <b-icon @click="click(3)" @mouseover="hoverIn(3)" @mouseleave="hoverOut(0)" :icon="starIcon3" :font-scale="fontScale" :style="style3" class="mr-1"/>
        <b-icon @click="click(4)" @mouseover="hoverIn(4)" @mouseleave="hoverOut(0)" :icon="starIcon4" :font-scale="fontScale" :style="style4" class="mr-1"/>
        <b-icon @click="click(5)" @mouseover="hoverIn(5)" @mouseleave="hoverOut(0)" :icon="starIcon5" :font-scale="fontScale" :style="style5" class="mr-1"/>
        {{starDescription}}
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    props: {
        rating: {
            type: Number
        },
        fontScale: {
            type: Number,
            default: 1
        },
        readOnly: {
            type: Boolean
        }
    },
    data() {
        return {
            hoverRating: 0,
            clickedRating: 0,
            starDescription: "Select your rating",
            starIcon1: "star",
            starIcon2: "star",
            starIcon3: "star",
            starIcon4: "star",
            starIcon5: "star",
            style1: "color: #D3D3D3;",
            style2: "color: #D3D3D3;",
            style3: "color: #D3D3D3;",
            style4: "color: #D3D3D3;",
            style5: "color: #D3D3D3;"
        }
    },
    methods: {
        hoverIn(starNumber) {
            // exit immediately if true
            console.log('hoverIn readOnly', this.readOnly)
            if (this.readOnly) {
                console.log('hoverIn exiting')
                return
            }
            console.log('starNumber: ', starNumber)
            this.hoverRating = starNumber
            if (starNumber == 0) {
                this.emptyAllStars()
            } else if (starNumber == 1) {
                this.activateStar1()
            } else if (starNumber == 2) {
                this.activateStar2()
            } else if (starNumber == 3) {
                this.activateStar3()
            } else if (starNumber == 4) {
                this.activateStar4()
            } else if (starNumber == 5) {
                this.activateStar5()
            }
            
        },
        hoverOut(starNumber) {
            if (this.readOnly) {
                return
            }
            console.log('hoverOut', starNumber)
            if (starNumber != this.clickedRating) {
                if (this.clickedRating == 1) {
                    this.activateStar1()
                } else if (this.clickedRating == 2) {
                    this.activateStar2()
                } else if (this.clickedRating == 3) {
                    this.activateStar3()
                } else if (this.clickedRating == 4) {
                    this.activateStar4()
                } else if (this.clickedRating == 5) {
                    this.activateStar5()
                }
            } else {
                this.emptyAllStars()
            }
        },
        click(starNumber) {
            if (this.readOnly) {
                return
            }
            console.log('clicked', starNumber)
            this.clickedRating = starNumber
        },
        emptyAllStars() {
            this.starIcon1 = "star"
            this.starIcon2 = "star"
            this.starIcon3 = "star"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #D3D3D3;"
            this.style2 = "color: #D3D3D3;"
            this.style3 = "color: #D3D3D3;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
            this.starDescription = "Select your rating"
        },
        activateStar1() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star"
            this.starIcon3 = "star"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #D3D3D3;"
            this.style3 = "color: #D3D3D3;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
            this.starDescription = "Not good"
        },
        activateStar2() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FFA500;"
            this.style2 = "color: #FFA500;"
            this.style3 = "color: #D3D3D3;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
            this.starDescription = "Could've been better"
        },
        activateStar3() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-fill"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FF8C00;"
            this.style2 = "color: #FF8C00;"
            this.style3 = "color: #FF8C00;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
            this.starDescription = "OK"
        },
        activateStar4() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-fill"
            this.starIcon4 = "star-fill"
            this.starIcon5 = "star"
            this.style1 = "color: #FF6347;"
            this.style2 = "color: #FF6347;"
            this.style3 = "color: #FF6347;"
            this.style4 = "color: #FF6347;"
            this.style5 = "color: #D3D3D3;"
            this.starDescription = "Good"
        },
        activateStar5() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-fill"
            this.starIcon4 = "star-fill"
            this.starIcon5 = "star-fill"
            this.style1 = "color: #FF4500;"
            this.style2 = "color: #FF4500;"
            this.style3 = "color: #FF4500;"
            this.style4 = "color: #FF4500;"
            this.style5 = "color: #FF4500;"
            this.starDescription = "Great"
        },
        // half stars
        activateStar0_5() {
            this.starIcon1 = "star-half"
            this.starIcon2 = "star"
            this.starIcon3 = "star"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #D3D3D3;"
            this.style3 = "color: #D3D3D3;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
        },
        activateStar1_5() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-half"
            this.starIcon3 = "star"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #FFD700;"
            this.style3 = "color: #D3D3D3;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
        },
        activateStar2_5() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-half"
            this.starIcon4 = "star"
            this.starIcon5 = "star"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #FFD700;"
            this.style3 = "color: #FFD700;"
            this.style4 = "color: #D3D3D3;"
            this.style5 = "color: #D3D3D3;"
        },
        activateStar3_5() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-fill"
            this.starIcon4 = "star-half"
            this.starIcon5 = "star"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #FFD700;"
            this.style3 = "color: #FFD700;"
            this.style4 = "color: #FFD700;"
            this.style5 = "color: #D3D3D3;"
        },
        activateStar4_5() {
            this.starIcon1 = "star-fill"
            this.starIcon2 = "star-fill"
            this.starIcon3 = "star-fill"
            this.starIcon4 = "star-fill"
            this.starIcon5 = "star-half"
            this.style1 = "color: #FFD700;"
            this.style2 = "color: #FFD700;"
            this.style3 = "color: #FFD700;"
            this.style4 = "color: #FFD700;"
            this.style5 = "color: #FFD700;"
        },
    },
    mounted() {
        // use the rating to set the star
        console.log('this.readOnly', this.readOnly)
        console.log('this.rating', this.rating)
        if (this.readOnly) {
            if (this.rating == 0) {
                this.emptyAllStars()
            } else if (this.rating > 0 && this.rating < 1) {
                this.activateStar0_5()
            } else if (this.rating == 1) {
                this.activateStar1()
            } else if (this.rating > 1 && this.rating < 2) {
                this.activateStar1_5()
            } else if (this.rating == 2) {
                this.activateStar2()
            } else if (this.rating > 2 && this.rating < 3) {
                this.activateStar2_5()
            } else if (this.rating == 3) {
                this.activateStar3()
            } else if (this.rating > 3 && this.rating < 4) {
                this.activateStar3_5()
            } else if (this.rating == 4) {
                this.activateStar4()
            } else if (this.rating > 4 && this.rating < 5) {
                this.activateStar4_5()
            } else if (this.rating == 5) {
                this.activateStar5()
            }
            // remove placeholder if read only / for display only
            this.starDescription = ""
        }
    }
    
}
</script>